module.exports = __webpack_public_path__ + "static/media/info-company.b8b0d087.jpeg";